<ion-app>
  <!-- main header -->
  <ion-header>
    <app-trec-toolbar></app-trec-toolbar>
  </ion-header>

  <!-- lateral menu -->
  <ion-menu side="start" [menuId]="SIDE_MENU_MAIN" contentId="mainContent" class="app-lateral-menu"
            (ionDidClose)="onMainMenuClose()">
    <app-menu-lateral></app-menu-lateral>
  </ion-menu>

  <ion-content>
    <div class="container">
      <!-- main content -->
      <ion-router-outlet id="mainContent" [animated]="false"></ion-router-outlet>
      <app-voice-assistant-feature *ngIf="hasConfiguratoreAssistant && isAuthenticated"></app-voice-assistant-feature>
    </div>
  </ion-content>

  <ion-menu side="end" [menuId]="SIDE_MENU_NOTIFICATION_CENTER" contentId="mainContent" class="app-lateral-menu">
    <c3-notification-center></c3-notification-center>
  </ion-menu>
</ion-app>